<template src="./rightbar.html"></template>

<script>
/* Sidebar contact: SM8 job badge lives inside .sidebar-contact-field (no dropdown caret). */
import Vue from 'vue'
import array from '../../../helpers/array'
import PreviewModal from '../modals/preview/preview'
import SendModal from '../modals/send/send'
import CustomerModal from '../modals/customer/customer'
// import {clone} from "../../../helpers/clone";
import OptionModal from '../modals/send/option';
import DuplicateOptionModal from '../modals/duplicate/DuplicateOptionModal.vue';
import PricingPinVerificationModal from '../../common/PricingPinVerificationModal.vue';
import QuoteTotalsModal from '../modals/QuoteTotalsModal.vue';
import {clone, isEqual} from "lodash";
import { clone as deepClone } from '../../../helpers/clone';
import axios from "axios";
import { isCalculatedQuoteTask, isTimeBasedQuoteTask } from '../../../helpers/calculatedQuoteDisplay';
import { bankersRound, calculateQuoteTotals, getQuoteLineUnitPrice } from '../../../helpers/quoteTotals';
import { calculateQuoteMargin } from '../../../helpers/quoteMargin';
import { isQuoteStatusLocked, coerceQuoteStatusFields } from '../../../helpers/quoteStatus';
import { isPricingProtectionEnabled } from '../../../helpers/pricingPin';
import moment from 'moment'
import {
    DEFAULT_QUOTE_VALIDITY_DAYS,
    addDaysYmd,
    quoteValidityDaysFromSettings
} from '../../../helpers/documentDefaultDays'
import serviceM8IconSrc from '../../../assets/img/icn_servicem8.png'

const today = moment().format('YYYY-MM-DD')
const dueDefault = addDaysYmd(today, DEFAULT_QUOTE_VALIDITY_DAYS)

const STATUS_DRAFT = 1
const STATUS_SENT = 2
const STATUS_ACCEPTED = 3
const STATUS_SIGNED = 4
const STATUS_INVOICED = 5
const STATUS_DECLINED = 6

const EXCLUDED_CATEGORY = [
    35,
    36,
    38,
    250
]

export default {
    name: 'QuoteRightBar',
    components: {
        'app-preview-modal': PreviewModal,
        'app-send-modal': SendModal,
        'app-customer': CustomerModal,
        'contact-select': require('../ContactSelect.vue').default,
        OptionModal,
        DuplicateOptionModal,
        'app-pricing-pin-verification-modal': PricingPinVerificationModal,
        'app-quote-totals-modal': QuoteTotalsModal,
    },
    props: {
        parent_quote: {
            type: Object
        },
        parent_quote_items: {
            type: Array
        },
        parent_calculateTask: {
            type: Function
        },
        parent_editTask: {
            type: Function
        },
    },
    watch: {
        quoteItems: {
            handler: function (after, before) {
                this.quote.items = this.quoteItems
                this.calculateTotals()
            },
            deep: true
        },
        quote: {
            handler: function (after, before) {
                if (this.quote.contact && this.quote.contact.id != null) {
                    this.contact = this.quote.contact
                }
            },
            deep: true
        },
        contact: function (after, before) {
            if (this.contact && this.contact.id != null) {
                this.quote.contact_id = this.contact.id
                this.quote.contact = this.contact
            }
        },
        parent_quote: {
            handler: function (after, before) {
                this.quote = this.parent_quote
                const normalized = this.normalizeQuoteItems(this.quote.items || [])
                this.quoteItems = normalized
                this.quote.items = normalized
                // Parent may still hold an old quoteItems array reference; keep it aligned with quote.items.
                this.$emit('line-items-sync', normalized)
                this.contact = (this.quote.contact && this.quote.contact.id != null) ? this.quote.contact : this.contact
                this.original = clone(this.quote);
                if (Array.isArray(this.quote.options) && this.quote.options.length && !this.quote._savedOptionBaselines) {
                    this.rememberSavedOptionBaselines(this.quote.options)
                }
            },
            deep: false
        },
        // parent_quote_items: {
        //     handler: function (after, before) {
        //         // this.quoteItems = this.parent_quote_items
        //     },
        //     deep: false
        // }
    },
    data: function () {
        return {
            contact: null,
            contacts: [],
            duplicateQuoteId: null,
            duplicating: false,
            duplicateChooserVisible: false,
            quote: {
                number: null,
                contact_id: null,
                callout_fee: 0,
                contact: {},
                gst_total: '0.00',
                sub_total: '0.00',
                total: '0.00',
                labour_time_hours: 0,
                labour_time_minutes: 0,
                discount: 0,
                discount_override: 0,
                discount_mode: null,
                discount_preset_id: null,
                discount_title: null,
                discount_description: null,
                discount_type: null,
                discount_value: null,
                discount_amount_applied: 0,
                items: [
                    {
                        callout_fee: 0,
                        qty: 0,
                        sell_price: 0
                    }
                ],
                status_id: 0,
                date: today,
                due_date: dueDefault,
                service_m8_job_id: null,
                service_m8_job_number: null
            },
            quoteItems: [],
            previewModalVisible: false,
            sendModalVisible: false,
            optionModalVisible: false,
            customerModalVisible: false,
            relinkModalVisible: false,
            original: {},
            saving: false,
            isOpen: false,
            pricingDetailsOpen: false,
            pricingDetailsModalVisible: false,
            pricingPinModalVisible: false,
            pendingPricingReveal: null,
            contactSearchLoading: false,
            draggedIndex: null,
            dragOverIndex: null,
            quoteValidityDays: DEFAULT_QUOTE_VALIDITY_DAYS,
            serviceM8IconSrc: serviceM8IconSrc
        }
    },
    computed: {
        quoteType: function () {
            if (this.quote.id) {
                return 'Edit'
            } else {
                return 'New'
            }
        },
        quoteMarginSummary: function () {
            return calculateQuoteMargin(this.quote, this.quoteItems, this.quote.discount)
        },
        safeContact: function () {
            return this.contact || {}
        },
        contactDisplayName: function () {
            const c = this.contact
            if (!c) return ''
            if (c.company) return c.company
            if (c.name) return c.name
            const full = ((c.first_name || '') + ' ' + (c.last_name || '')).trim()
            return full
        },
        hasSm8Job: function () {
            const n = this.quote && this.quote.service_m8_job_number
            return n != null && String(n).trim() !== ''
        },
        sm8JobLabel: function () {
            if (!this.hasSm8Job) return ''
            return 'Job #' + String(this.quote.service_m8_job_number).trim()
        },
        sidebarItems: function () {
            return this.quoteItems.filter(function (item) {
                return item.deleted !== 1
            })
        },
        tasks: function () {
            let items = []
            this.quoteItems.forEach(function (item) {
                const categories = Array.isArray(item.categories) ? item.categories : []
                const firstId = categories[0] && categories[0].id
                if (item.item_type === 'task' && (firstId !== 36 && firstId !== 38)) {
                    items.push(item)
                }
            })
            return items
        },
        products: function () {
            let items = []
            this.quoteItems.forEach(function (item) {
                if (item.item_type === 'product') {
                    items.push(item)
                }
            })
            return items
        },
        fees: function () {
            let items = []
            this.quoteItems.forEach(function (item) {
                const categories = Array.isArray(item.categories) ? item.categories : []
                const firstId = categories[0] && categories[0].id
                if (item.item_type === 'task' && firstId === 36) {
                    items.push(item)
                }
            })
            return items
        },
        certs: function () {
            let items = []
            this.quoteItems.forEach(function (item) {
                const categories = Array.isArray(item.categories) ? item.categories : []
                const firstId = categories[0] && categories[0].id
                if (item.item_type === 'task' && firstId === 38) {
                    items.push(item)
                }
            })
            return items
        },
        clean () { return Object.keys(this.diff).length === 0; },
        diff() {
            return Object.keys(this.quote).reduce((diff, key) => isEqual(this.quote[key], this.original[key]) ? diff : Object.assign(diff, {[key]: this.quote[key]}), {});
        },
    },
    methods: {
        clone,
        normalizeQuoteItems: function (items) {
            return (items || []).map(item => {
                const itemType = item.item_type === 'material' ? 'product' : item.item_type
                const qtyRaw = item.qty != null ? item.qty : (item.quantity != null ? item.quantity : 1)
                const qtyNum = Number(qtyRaw)
                const sellPrice = item.sell_price != null ? item.sell_price : (item.unit_price != null ? item.unit_price : 0)
                const labourHours = item.labour_time_hours != null ? item.labour_time_hours : (item.labour_hours != null ? item.labour_hours : 0)
                const labourMinutes = item.labour_time_minutes != null ? item.labour_time_minutes : (item.labour_minutes != null ? item.labour_minutes : 0)
                const location = item.location != null ? item.location : (item.hourly_rate_multiplier != null ? item.hourly_rate_multiplier : 1)
                return Object.assign({}, item, {
                    item_type: itemType,
                    // Qty should always be whole on the quote/invoice.
                    qty: Number.isFinite(qtyNum) && qtyNum > 0 ? Math.round(qtyNum) : 1,
                    sell_price: sellPrice,
                    labour_time_hours: labourHours,
                    labour_time_minutes: labourMinutes,
                    location,
                    categories: Array.isArray(item.categories) ? item.categories : []
                })
            })
        },
        initDuplicate: function (quoteId) {
            this.duplicateQuoteId = quoteId;
            this.duplicateChooserVisible = true;
        },
        closeDuplicateChooser: function () {
            this.duplicateChooserVisible = false;
        },
        onDuplicateVariation: function () {
            const quoteId = this.duplicateQuoteId || (this.quote && this.quote.id);
            if (quoteId == null || quoteId === '' || String(quoteId) === 'undefined') {
                this.errorNotification && this.errorNotification('Please save the quote before adding a variation');
                this.duplicateChooserVisible = false;
                return;
            }
            // Copy from currently selected option (or last if unset)
            this.persistActiveOptionIntoQuote();
            const sourceId = this.quote && this.quote.active_option_id;
            this.duplicateChooserVisible = false;
            axios.post(`/quote/${quoteId}/options`, { source_option_id: sourceId || null }).then((response) => {
                const options = response.data.options || [];
                const newOpt = response.data.option;
                this.$set(this.quote, 'options', options);
                this.rememberSavedOptionBaselines(options);
                if (newOpt) {
                    // Newly created variation becomes the selected option
                    this.$set(this.quote, 'active_option_id', newOpt.id);
                    this.$set(this.quote, 'active_option_index', newOpt.option_index);
                    const full = options.find((o) => o.id === newOpt.id) || newOpt;
                    if (full && Array.isArray(full.items)) {
                        const items = deepClone(full.items);
                        this.quoteItems = items;
                        this.quote.items = items;
                        this.$emit('line-items-sync', items);
                    }
                    this.$set(this.quote, 'discount_mode', full.discount_mode);
                    this.$set(this.quote, 'discount_preset_id', full.discount_preset_id);
                    this.$set(this.quote, 'discount_title', full.discount_title);
                    this.$set(this.quote, 'discount_description', full.discount_description);
                    this.$set(this.quote, 'discount_type', full.discount_type);
                    this.$set(this.quote, 'discount_value', full.discount_value);
                    const applied = Number(full.discount_amount_applied) || 0;
                    this.$set(this.quote, 'discount_amount_applied', applied);
                    this.$set(this.quote, 'discount_override', applied);
                    if (full.total != null) {
                        this.quote.total = full.total;
                        this.quote.total_amount = full.total;
                    }
                }
                // Remount preview so segment control picks up the new selection
                this.previewModalVisible = false;
                this.$nextTick(() => {
                    this.previewModalVisible = true;
                });
            }).catch((err) => {
                const msg = err.response && err.response.data && err.response.data.error
                    ? err.response.data.error
                    : 'Failed to add variation';
                this.errorNotification && this.errorNotification(msg);
                this.previewModalVisible = true;
            });
        },
        onDuplicateNewQuote: function () {
            this.duplicating = false
            this.duplicateChooserVisible = false;
            this.previewModalVisible = false;
            this.customerModalVisible = true;
        },
        duplicate: function (payload) {
            if (this.duplicating) return
            if (!payload || !payload.contact || !payload.contact.id || !this.duplicateQuoteId) {
                this.$nextTick(() => {
                    if (this.$refs.duplicateCustomer && this.$refs.duplicateCustomer.resetSubmitting) {
                        this.$refs.duplicateCustomer.resetSubmitting()
                    }
                })
                return
            }
            this.duplicating = true
            this.customerModalVisible = false
            axios.post(`/quote/${this.duplicateQuoteId}/duplicate`, {
                contact_id: payload.contact.id,
                job_id: payload.service_m8_job
            }).then(response => {
                const id = (response.data && response.data.data && response.data.data.id)
                    || (response.data && response.data.id)
                this.$router.push('/quote/' + id)
            }).catch(err => {
                this.duplicating = false
                this.customerModalVisible = true
                const msg = err.response && err.response.data && err.response.data.error
                    ? err.response.data.error
                    : 'Failed to duplicate quote'
                this.errorNotification && this.errorNotification(msg)
            })
        },
        onPreviewOptionChange: function (opt) {
            if (!opt) return
            this.$set(this.quote, 'active_option_id', opt.id)
            this.$set(this.quote, 'active_option_index', opt.option_index)
            // Keep session selection sticky while working; DB last_active updates on save
            this.$set(this.quote, 'last_active_option_id', opt.id)
            if (Array.isArray(opt.items)) {
                const items = deepClone(opt.items)
                this.quoteItems = items
                this.quote.items = items
                this.$emit('line-items-sync', items)
            }
            // Keep discount fields aligned with the selected option
            this.$set(this.quote, 'discount_mode', opt.discount_mode)
            this.$set(this.quote, 'discount_preset_id', opt.discount_preset_id)
            this.$set(this.quote, 'discount_title', opt.discount_title)
            this.$set(this.quote, 'discount_description', opt.discount_description)
            this.$set(this.quote, 'discount_type', opt.discount_type)
            this.$set(this.quote, 'discount_value', opt.discount_value)
            const applied = Number(opt.discount_amount_applied) || 0
            this.$set(this.quote, 'discount_amount_applied', applied)
            this.$set(this.quote, 'discount_override', applied)
            if (opt.total != null) {
                this.quote.total = opt.total
                this.quote.total_amount = opt.total
            }
            if (opt.reference !== undefined) {
                this.$set(this.quote, 'reference', opt.reference != null ? opt.reference : '')
            }
        },
        persistActiveOptionIntoQuote: function () {
            const opts = Array.isArray(this.quote.options) ? this.quote.options : []
            if (!opts.length) return
            let active = null
            if (this.quote.active_option_id) {
                active = opts.find((o) => o.id === this.quote.active_option_id)
            }
            if (!active && this.quote.active_option_index) {
                active = opts.find((o) => o.option_index === Number(this.quote.active_option_index))
            }
            if (!active) active = opts[0]
            if (!active) return
            active.items = Array.isArray(this.quoteItems) ? deepClone(this.quoteItems) : []
            active.total = this.quote.total
            active.reference = this.quote.reference != null ? this.quote.reference : ''
            active.discount_mode = this.quote.discount_mode
            active.discount_preset_id = this.quote.discount_preset_id
            active.discount_title = this.quote.discount_title
            active.discount_description = this.quote.discount_description
            active.discount_type = this.quote.discount_type
            active.discount_value = this.quote.discount_value
            active.discount_amount_applied = this.quote.discount_amount_applied
            this.$set(this.quote, 'active_option_id', active.id)
            this.$set(this.quote, 'active_option_index', active.option_index)
            this.$set(this.quote, 'options', opts)
        },
        rememberSavedOptionBaselines: function (options) {
            const opts = Array.isArray(options) ? options : (this.quote.options || [])
            this.$set(this.quote, '_savedOptionBaselines', deepClone(opts))
        },
        editTask: function (item) {
            if (isCalculatedQuoteTask(item)) {
                this.parent_calculateTask(item, true);
                return;
            }

            this.parent_editTask(item);
        },
        calculateQuoteTotal: function () {
            this.quote.callout_fee = 0
            const totals = calculateQuoteTotals(this.quote, this.quoteItems)
            this.quote.discount = totals.discount
            this.quote.sub_total = totals.sub_total
            this.quote.gst_total = totals.gst_total
            this.quote.total = totals.total
        },
        bankersRound,
        calculateLabourTime: function () {
            this.quote.labour_time_hours = 0
            this.quote.labour_time_minutes = 0

            if (this.quoteItems.length > 0) {
                for (let i = 0; i < this.quoteItems.length; i++) {
                    if (this.quoteItems[i].item_type === 'task') {
                        this.quote.labour_time_hours += ((this.quoteItems[i].labour_time_hours * (this.quoteItems[i].location || 1)) * this.quoteItems[i].qty)
                        this.quote.labour_time_minutes += ((this.quoteItems[i].labour_time_minutes * (this.quoteItems[i].location || 1)) * this.quoteItems[i].qty)
                    }
                }

                let totalMinutes = this.quote.labour_time_minutes + (this.quote.labour_time_hours * 60)
                let duration = this.moment.duration(totalMinutes, 'minutes')
                this.quote.labour_time_hours = duration.hours()
                this.quote.labour_time_minutes = duration.minutes()
            }
        },
        getTaskCount: function () {
            let count = 0
            for (let i = 0; i < this.quoteItems.length; i++) {
                if (this.quoteItems[i].item_type === 'task') {
                    if (this.excludedFromSmartPricing(this.quoteItems[i]) === false) {
                        count += this.quoteItems[i].qty
                    }
                }
            }
            return count
        },
        calculateTaskCalloutFee: function () {
            let callout = this.$store.getters['setting/getAccount'].callout_fee / this.getTaskCount()
            for (let i = 0; i < this.quoteItems.length; i++) {
                if (this.quoteItems[i].item_type === 'task') {
                    if (this.excludedFromSmartPricing(this.quoteItems[i]) === false) {
                        this.quoteItems[i].callout_fee = callout
                    }
                }
            }
        },
        updateQty: function (item, event) {
            const oldQty = Number(item.qty) || 1
            const newQty = Number(event.id) || 1
            if (newQty !== oldQty && (isCalculatedQuoteTask(item) || isTimeBasedQuoteTask(item)) && oldQty > 0) {
                const sell = Number(item.sell_price) || 0
                item.sell_price = bankersRound((sell / oldQty) * newQty, 2)
            }
            item.qty = newQty
            this.calculateTotals()
        },
        taskUnitPrice: function (item) {
            return getQuoteLineUnitPrice(item)
        },
        finalizeQuoteLineItemsChange: function () {
            this.quote.items = this.quoteItems
            this.persistActiveOptionIntoQuote()
            this.$emit('line-items-sync', this.quoteItems)
            this.calculateTotals()
        },
        deleteItem: function (item) {
            this.swal({
                title: 'Remove item from quote?',
                text: 'This action will remove this item from the current quote and cannot be undone.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Yes, remove!'
            }).then((result) => {
                if (!result.value) {
                    return;
                }

                if (this.quote.id && item.id != null && String(item.id) !== '') {
                    const qid = this.quote.id
                    const rowId = item.id
                    axios.delete(`/api/quotes/${qid}/items/${rowId}`).then(() => {
                        this.removeQuoteLineItem(this.quoteItems, item)
                        this.finalizeQuoteLineItemsChange()
                    }).catch((err) => {
                        const msg = (err.response && err.response.data && err.response.data.error) || err.message || 'Could not remove line'
                        if (this.errorNotification) this.errorNotification(msg)
                    })
                } else {
                    this.removeQuoteLineItem(this.quoteItems, item)
                    this.finalizeQuoteLineItemsChange()
                }
            })
        },
        applyDiscount: function (discount) {
            if (discount && typeof discount === 'object') {
                this.$set(this.quote, 'discount_mode', discount.discount_mode || null)
                this.$set(this.quote, 'discount_preset_id', discount.discount_preset_id != null ? discount.discount_preset_id : null)
                this.$set(this.quote, 'discount_title', discount.discount_title != null && discount.discount_title !== '' ? discount.discount_title : null)
                this.$set(this.quote, 'discount_description', discount.discount_description != null && discount.discount_description !== '' ? discount.discount_description : null)
                this.$set(this.quote, 'discount_type', discount.discount_type || null)
                this.$set(this.quote, 'discount_value', discount.discount_value != null ? discount.discount_value : null)
                const applied = Number(discount.discount_amount_applied)
                const appliedNum = Number.isFinite(applied) ? applied : 0
                this.$set(this.quote, 'discount_amount_applied', appliedNum)
                this.$set(this.quote, 'discount_override', appliedNum)
            } else {
                const amount = Number(discount) || 0
                this.quote.discount_mode = amount > 0 ? 'adhoc' : null
                this.quote.discount_preset_id = null
                this.quote.discount_title = amount > 0 ? 'Amount Off' : null
                this.quote.discount_description = null
                this.quote.discount_type = amount > 0 ? 'amount' : null
                this.quote.discount_value = amount > 0 ? amount : null
                this.quote.discount_amount_applied = amount
                this.quote.discount_override = amount
            }
            this.persistActiveOptionIntoQuote()
            this.calculateQuoteTotal();
        },
        calculateTotals: function () {
            if (this.$store.getters['setting/getAccount'].price_structure === 2) {
                this.calculateTaskCalloutFee()
            }
            this.calculateLabourTime()
            this.calculateQuoteTotal()
        },
        onContactSearch: function (searchText) {
            if (searchText && searchText.trim().length >= 2) {
                this.contactSearchLoading = true
                axios.post('/api/contact/fetch/search', { text: searchText.trim() }).then(response => {
                    this.contacts = response.data.contacts || response.data || []
                }).catch(() => {
                    this.contacts = []
                }).finally(() => {
                    this.contactSearchLoading = false
                })
            } else {
                this.contacts = []
            }
        },
        searchContacts: function (name) {
            this.onContactSearch(name)
        },
        openRelinkModal: function () {
            this.relinkModalVisible = true
        },
        onRelink: function (data) {
            if (!data || !data.contact || !data.contact.id) return
            this.contact = data.contact
            this.quote.contact = data.contact
            this.quote.contact_id = data.contact.id
            if (data.service_m8_job) {
                this.quote.service_m8_job_id     = data.service_m8_job.uuid
                this.quote.service_m8_job_number = String(data.service_m8_job.generated_job_id)
            } else {
                this.quote.service_m8_job_id     = null
                this.quote.service_m8_job_number = null
            }
            this.relinkModalVisible = false
        },
        save: function (simple = true, silent = false, forcePersistLocked = false, optionsToSave = null) {
            return this.saveQuote(simple, silent, forcePersistLocked, optionsToSave)
        },
        buildQuotePutPayload: function (forOption) {
            this.calculateTotals()
            const issuedHint = this.quote.quote_date || this.quote.date
            if (issuedHint) {
                const m = this.moment(String(issuedHint), ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY'], true)
                if (m.isValid()) this.quote.quote_date = m.format('YYYY-MM-DD')
            }

            let quote = clone(this.quote)
            quote.contact_id = quote.contact_id != null ? quote.contact_id : (this.contact && this.contact.id != null ? this.contact.id : null)
            quote.company_id = quote.company_id != null ? quote.company_id : (this.contact && this.contact.company_id != null ? this.contact.company_id : null) || (this.$store.getters['user/getProfile'] && this.$store.getters['user/getProfile'].company_id)
            if (quote.terms !== undefined) quote.notes = quote.terms
            quote.discount_mode = forOption ? forOption.discount_mode : this.quote.discount_mode
            quote.discount_preset_id = forOption ? forOption.discount_preset_id : this.quote.discount_preset_id
            quote.discount_title = forOption ? forOption.discount_title : this.quote.discount_title
            quote.discount_description = forOption ? forOption.discount_description : this.quote.discount_description
            quote.discount_type = forOption ? forOption.discount_type : this.quote.discount_type
            quote.discount_value = forOption ? forOption.discount_value : this.quote.discount_value
            // Prefer explicit amount_applied (including 0). Do not treat 0 as missing and fall through to override.
            if (forOption) {
                quote.discount_amount_applied = Number(forOption.discount_amount_applied) || 0
            } else if (this.quote.discount_amount_applied != null && this.quote.discount_amount_applied !== '') {
                quote.discount_amount_applied = Number(this.quote.discount_amount_applied) || 0
            } else {
                quote.discount_amount_applied = Number(this.quote.discount_override) || 0
            }
            quote.reference = forOption && forOption.reference !== undefined ? forOption.reference : (this.quote.reference != null ? this.quote.reference : '')
            if (quote.due_date) {
                const dm = this.moment(String(quote.due_date), ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY'], true)
                quote.valid_until = dm.isValid() ? dm.format('YYYY-MM-DD') : quote.due_date
            }
            if (quote.quote_date || quote.date) {
                const raw = quote.quote_date || quote.date
                if (raw) {
                    const m = this.moment(String(raw), ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY'], true)
                    if (m.isValid()) quote.quote_date = m.format('YYYY-MM-DD')
                }
            }
            quote.total_amount = forOption && forOption.total != null ? forOption.total : quote.total
            quote.total = quote.total_amount
            const itemsSource = forOption && Array.isArray(forOption.items) ? forOption.items : (this.quoteItems || [])
            if (forOption) {
                quote.active_option_id = forOption.id
                quote.active_option_index = forOption.option_index
            } else if (this.quote.active_option_id) {
                quote.active_option_id = this.quote.active_option_id
                quote.active_option_index = this.quote.active_option_index
            }
            quote.items = itemsSource.map(i => {
                const copy = Object.assign({}, i)
                delete copy.materials
                if (copy.hasOwnProperty('calculations') && Array.isArray(copy.calculations)) {
                    copy.calculations = copy.calculations.map(c => {
                        c.fittings = c.fittings ? c.fittings.filter(fitting => fitting.qty > 0) : []
                        c.fixings = c.fixings ? c.fixings.filter(fixing => fixing.qty > 0) : []
                        return c
                    })
                }
                return copy
            })
            coerceQuoteStatusFields(quote)
            return quote
        },
        applySaveResponse: function (payload, silent) {
            const saved = payload.quote || {}
            if (saved.quote_date) this.quote.quote_date = saved.quote_date
            if (saved.valid_until) {
                this.quote.valid_until = saved.valid_until
                this.quote.due_date = this.moment(saved.valid_until).format('YYYY-MM-DD')
            }
            if (saved.status) {
                this.quote.status = saved.status
                const sm = { draft: 1, sent: 2, accepted: 3, rejected: 6, declined: 6, invoiced: 5 }
                this.quote.status_id = sm[saved.status] || this.quote.status_id
            }
            if (saved.reference != null) this.quote.reference = saved.reference
            if (Object.prototype.hasOwnProperty.call(saved, 'service_m8_job_id')) {
                this.$set(this.quote, 'service_m8_job_id', saved.service_m8_job_id || null)
            }
            if (Object.prototype.hasOwnProperty.call(saved, 'service_m8_job_number')) {
                this.$set(this.quote, 'service_m8_job_number', saved.service_m8_job_number || null)
            }
            if (Object.prototype.hasOwnProperty.call(saved, 'signed_by_name')) {
                this.$set(this.quote, 'signed_by_name', saved.signed_by_name || null)
            }
            if (Object.prototype.hasOwnProperty.call(saved, 'signature_data')) {
                this.$set(this.quote, 'signature_data', saved.signature_data || null)
            }
            if (Object.prototype.hasOwnProperty.call(saved, 'signed_at')) {
                this.$set(this.quote, 'signed_at', saved.signed_at || null)
            }
            const savedOptions = payload.options || saved.options
            if (Array.isArray(savedOptions) && savedOptions.length) {
                this.$set(this.quote, 'options', savedOptions)
                this.rememberSavedOptionBaselines(savedOptions)
            }
            if (saved.active_option_id) {
                this.$set(this.quote, 'active_option_id', saved.active_option_id)
            }
            if (saved.active_option_index) {
                this.$set(this.quote, 'active_option_index', saved.active_option_index)
            }
            if (saved.last_active_option_id) {
                this.$set(this.quote, 'last_active_option_id', saved.last_active_option_id)
            }
            const activeId = this.quote.active_option_id
            const opts = this.quote.options || []
            const activeOpt = activeId ? opts.find((o) => o.id === activeId) : null
            if (activeOpt && Array.isArray(activeOpt.items)) {
                const items = deepClone(activeOpt.items)
                this.quote.items = items
                this.quoteItems = items
                if (activeOpt.reference !== undefined) {
                    this.quote.reference = activeOpt.reference
                }
                this.$set(this.quote, 'discount_mode', activeOpt.discount_mode)
                this.$set(this.quote, 'discount_preset_id', activeOpt.discount_preset_id)
                this.$set(this.quote, 'discount_title', activeOpt.discount_title)
                this.$set(this.quote, 'discount_description', activeOpt.discount_description)
                this.$set(this.quote, 'discount_type', activeOpt.discount_type)
                this.$set(this.quote, 'discount_value', activeOpt.discount_value)
                const applied = Number(activeOpt.discount_amount_applied) || 0
                this.$set(this.quote, 'discount_amount_applied', applied)
                this.$set(this.quote, 'discount_override', applied)
            } else {
                this.quote.items = payload.quote_items || this.quote.items || []
                this.quoteItems = this.quote.items
            }
            if (!silent) {
                this.$emit('reset-default-task-price-type')
                this.successNotification()
                this.$router.push('/')
            }
            localStorage.removeItem('quote')
        },
        saveQuote: function (simple = true, silent = false, forcePersistLocked = false, optionsToSave = null) {
            // Never-created empty quotes: leave without inserting a blank draft.
            // Existing quotes with all lines removed must still save so list totals go to $0.
            if ((!this.quoteItems || this.quoteItems.length === 0) && (this.quote.id == null || this.quote.id === '')) {
                this.$emit('reset-default-task-price-type')
                this.$router.push('/')
                return Promise.resolve()
            }

            this.saving = true
            this.persistActiveOptionIntoQuote()

            const opts = Array.isArray(this.quote.options) ? this.quote.options : []
            let optionIds = Array.isArray(optionsToSave) ? optionsToSave.map((id) => Number(id)).filter(Boolean) : null
            if (optionIds && optionIds.length) {
                const activeId = this.quote.active_option_id
                if (activeId && !optionIds.includes(Number(activeId))) {
                    optionIds.push(Number(activeId))
                }
            }

            if (optionIds && optionIds.length > 1 && this.quote.id) {
                const activeId = Number(this.quote.active_option_id)
                // Active option must be saved last so last_active_option_id matches user selection
                const ordered = optionIds
                    .map((id) => opts.find((o) => Number(o.id) === Number(id)))
                    .filter(Boolean)
                    .sort((a, b) => {
                        if (Number(a.id) === activeId) return 1
                        if (Number(b.id) === activeId) return -1
                        return (a.option_index || 0) - (b.option_index || 0)
                    })
                const runSequential = (index) => {
                    const opt = ordered[index]
                    const isLast = index === ordered.length - 1
                    const quotePayload = this.buildQuotePutPayload(opt)
                    const putSilent = !isLast || silent
                    const putSimple = isLast ? simple : true
                    return axios.put('/quote/' + this.quote.id, quotePayload).then((response) => {
                        if (isLast) {
                            this.saving = false
                            if (!putSimple && this.previewModalVisible) {
                                this.previewModalVisible = false
                                this.optionModalVisible = true
                            }
                            this.applySaveResponse(response.data.payload || {}, putSilent)
                            return response.data.payload
                        }
                        return runSequential(index + 1)
                    })
                }
                return new Promise((resolve, reject) => {
                    if (isQuoteStatusLocked(this.buildQuotePutPayload()) && !forcePersistLocked) {
                        this.saving = false
                        if (!simple && this.previewModalVisible) {
                            this.previewModalVisible = false
                            this.optionModalVisible = true
                        }
                        if (!silent) {
                            this.successNotification()
                            this.$router.push('/')
                        }
                        localStorage.removeItem('quote')
                        return resolve({ quote: this.quote, quote_items: this.quoteItems || [] })
                    }
                    runSequential(0).then(resolve).catch((err) => {
                        this.saving = false
                        reject(err)
                    })
                })
            }

            let quote = this.buildQuotePutPayload()

            if (!this.quote.number) {
                return new Promise((resolve, reject) => {
                    axios.post('/quote', quote).then(response => {
                        this.saving = false;
                        const payload = response.data.payload || {};
                        const created = payload.quote || response.data.quote;
                        this.quote.id = created && created.id;
                        this.quote.number = created && created.number;
                        if (created && created.total_amount != null) {
                            this.quote.total = Number(created.total_amount);
                            this.quote.total_amount = this.quote.total;
                        }
                        if (created && created.reference != null) {
                            this.$set(this.quote, 'reference', created.reference)
                        }
                        const createdOptions = (created && created.options) || payload.options
                        if (Array.isArray(createdOptions) && createdOptions.length) {
                            this.$set(this.quote, 'options', createdOptions)
                            this.rememberSavedOptionBaselines(createdOptions)
                        }
                        if (created && created.active_option_id) {
                            this.$set(this.quote, 'active_option_id', created.active_option_id)
                        }
                        if (created && created.active_option_index) {
                            this.$set(this.quote, 'active_option_index', created.active_option_index)
                        }
                        this.quote.items = (payload.quote_items && payload.quote_items.length)
                            ? payload.quote_items
                            : (this.quoteItems || this.quote.items || []);
                        this.quoteItems = this.quote.items

                        if (!simple && this.previewModalVisible) {
                            this.previewModalVisible = false
                            this.optionModalVisible = true
                        }

                        if (!silent) {
                            this.successNotification()
                            this.$router.push('/')
                        }

                        localStorage.removeItem('quote');

                        return resolve(response.data.payload);
                    }).catch(err => {
                        this.saving = false;
                        reject(err);
                    });
                });
            }

            return new Promise((resolve, reject) => {
                if (isQuoteStatusLocked(quote) && !forcePersistLocked) {
                    this.saving = false;
                    if (!simple && this.previewModalVisible) {
                        this.previewModalVisible = false
                        this.optionModalVisible = true
                    }
                    if (!silent) {
                        this.successNotification()
                        this.$router.push('/')
                    }
                    localStorage.removeItem('quote');
                    return resolve({ quote: this.quote, quote_items: this.quoteItems || [] });
                }

                axios.put('/quote/' + quote.id, quote).then(response => {
                    this.saving = false;
                    if (!simple && this.previewModalVisible) {
                        this.previewModalVisible = false
                        this.optionModalVisible = true
                    }
                    this.applySaveResponse(response.data.payload || {}, silent)
                    return resolve(response.data.payload);
                }).catch(err => {
                    this.saving = false;
                    reject(err);
                });
            })
        },
        previewButton: function () {
            if (!this.quote.contact) {
                const contactCompany = this.quote.contact_company || this.quote.contact_name || this.quote.company_name || ''
                this.quote.contact = { company: contactCompany }
            }
            if (!this.quote.terms && this.quote.notes) {
                this.quote.terms = this.quote.notes
            }
            coerceQuoteStatusFields(this.quote)
            if (!this.quote.status_id && this.quote.status) {
                const statusMap = { draft: STATUS_DRAFT, sent: STATUS_SENT, accepted: STATUS_ACCEPTED, declined: STATUS_DECLINED, rejected: STATUS_DECLINED }
                this.quote.status_id = statusMap[this.quote.status] || this.quote.status_id
            }
            if (!this.quote.due_date) {
                this.quote.due_date = this.quote.valid_until || (this.quote.created_at
                    ? addDaysYmd(this.quote.created_at, this.quoteValidityDays)
                    : null)
            }
            this.calculateTotals()
            // Prefer last-saved option snapshot (deep). Fallback deep-clones options
            // BEFORE merging editor edits — lodash clone is shallow and was sharing
            // option object refs, so persist mutated the "seed" too.
            const savedBaselines = this.quote._savedOptionBaselines
            const seed = Array.isArray(savedBaselines) && savedBaselines.length
                ? deepClone(savedBaselines)
                : deepClone(this.quote.options || [])
            this.$set(this.quote, '_previewOptionBaselinesSource', seed)
            this.persistActiveOptionIntoQuote()
            this.$emit('reset-default-task-price-type')
            this.previewModalVisible = true
        },
        sendQuoteButton: function () {
            this.save(false, true)
        },
        sendBackButton: function () {
            this.sendModalVisible = false
            this.optionModalVisible = false
            this.previewModalVisible = true
        },
        downloadPdf: function () {
            const isDraft = this.quote.status_id === 1 || this.quote.status_id === '1' || this.quote.status === 'draft'
            if (isDraft) {
                this.quote.status_id = STATUS_SENT
                this.quote.status = 'sent'
            }
            this.optionModalVisible = false

            const optIdx = this.quote.active_option_index || 1
            const fetchPdf = () => axios.get('/quote/' + this.quote.id + '/pdf', { responseType: 'blob', params: { option: optIdx } });
            const pdfPromise = isQuoteStatusLocked(this.quote)
                ? fetchPdf()
                : (() => {
                    if (this.quote.due_date) this.quote.valid_until = this.quote.due_date
                    const payload = Object.assign({}, this.quote)
                    coerceQuoteStatusFields(payload)
                    return axios.put('/quote/' + this.quote.id, payload).then(() => fetchPdf());
                })();

            pdfPromise.then(response => {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                const a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = fileURL;
                a.download = `${this.quote.number}-${optIdx}.pdf`;
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.swal({ type: 'success', title: 'Quote downloaded' }).then(() => {
                    if (this.$route.path !== '/') {
                        this.$router.push('/').catch(function () {});
                    }
                });
            }).catch(err => {
                this.errorNotification(err.response && err.response.data && err.response.data.error ? err.response.data.error : (err.message || 'Download failed'));
            });
        },
        removeQuoteLineItem (array, item) {
            if (!array || !item) return
            let idx = array.indexOf(item)
            if (idx === -1 && item.uuid != null && item.item_id != null) {
                idx = array.findIndex(function (line) {
                    return line.uuid === item.uuid && line.item_id === item.item_id
                })
            }
            if (idx === -1 && item.id != null && item.id !== '') {
                idx = array.findIndex(function (line) {
                    return line.id === item.id
                })
            }
            if (idx === -1 && item.uuid != null) {
                idx = array.findIndex(function (line) {
                    return line.uuid === item.uuid
                })
            }
            if (idx !== -1) {
                array.splice(idx, 1)
            }
        },
        removeById(array, uuid) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].uuid === uuid) {
                    array.splice(i, 1)
                    return
                }
            }
        },
        updateById(array, object) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].uuid === object.uuid) {
                    array[i] = object
                }
            }
            return array
        },
        excludedFromSmartPricing: function (task) {
            for (let i = 0; i < task.categories.length; i++) {
                if (task.categories[i].id === 35 || task.categories[i].id === 36 || task.categories[i].id === 38 || task.categories[i].id === 250) {
                    return true
                }
            }
            return false
        },
        toggleSidebar() {
            this.isOpen = !this.isOpen;
        },
        togglePricingDetails: function () {
            if (this.pricingDetailsOpen) {
                this.pricingDetailsOpen = false;
                return;
            }
            if (isPricingProtectionEnabled(this.$store)) {
                this.pendingPricingReveal = 'desktop';
                this.pricingPinModalVisible = true;
                return;
            }
            this.pricingDetailsOpen = true;
        },
        openPricingDetailsModal: function () {
            if (isPricingProtectionEnabled(this.$store)) {
                this.pendingPricingReveal = 'mobile';
                this.pricingPinModalVisible = true;
                return;
            }
            this.pricingDetailsModalVisible = true;
        },
        closePricingDetailsModal: function () {
            this.pricingDetailsModalVisible = false;
        },
        onPricingPinVerified: function () {
            if (this.pendingPricingReveal === 'mobile') {
                this.pricingDetailsModalVisible = true;
            } else {
                this.pricingDetailsOpen = true;
            }
            this.pendingPricingReveal = null;
            this.pricingPinModalVisible = false;
        },
        closePricingPinModal: function () {
            this.pricingPinModalVisible = false;
            this.pendingPricingReveal = null;
        },
        labourTimeHoursMinutes: function (item) {
            let totalMinutes = 0;

            totalMinutes = (item.labour_time_hours * 60) + item.labour_time_minutes;
            const labourTime = totalMinutes * (item.location || item.hourly_rate_multiplier || 1);

            return this.convertMinutesToHoursAndMinutes(labourTime);
        },
        convertMinutesToHoursAndMinutes: function (minutes) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = Math.floor(minutes % 60);
            return `${hours}h ${remainingMinutes}m`;
        },
        showSidebarQtySelect: function (item) {
            if (item.item_type === 'product') {
                return true
            }
            if (item.item_type !== 'task') {
                return true
            }
            const categories = Array.isArray(item.categories) ? item.categories : []
            const firstId = categories[0] && categories[0].id
            const isFeeOrCert = firstId === 36 || firstId === 38
            if (!isFeeOrCert) {
                return true
            }
            return item.type === 1
        },
        shouldIgnoreSidebarDrag: function (event) {
            const target = event.target
            if (!target || !target.closest) {
                return false
            }
            return !!target.closest('.quantity, .options, .ui.dropdown, select, button, input, textarea, a')
        },
        onSidebarDragStart: function (event, index) {
            if (this.shouldIgnoreSidebarDrag(event)) {
                event.preventDefault()
                return
            }
            this.draggedIndex = index
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('text/plain', String(index))
        },
        onSidebarDragOver: function (event, index) {
            event.preventDefault()
            if (this.draggedIndex !== null && this.draggedIndex !== index) {
                this.dragOverIndex = index
            }
        },
        onSidebarDragLeave: function (event, index) {
            if (this.dragOverIndex === index) {
                this.dragOverIndex = null
            }
        },
        onSidebarDrop: function (event, index) {
            event.preventDefault()
            if (this.draggedIndex !== null && this.draggedIndex !== index) {
                this.reorderSidebarItem(this.draggedIndex, index)
            }
            this.dragOverIndex = null
        },
        onSidebarDragEnd: function () {
            this.draggedIndex = null
            this.dragOverIndex = null
        },
        reorderSidebarItem: function (fromSidebarIndex, toSidebarIndex) {
            const visible = this.sidebarItems
            const fromItem = visible[fromSidebarIndex]
            const toItem = visible[toSidebarIndex]
            if (!fromItem || !toItem) {
                return
            }
            const items = this.quoteItems
            const fromIndex = items.indexOf(fromItem)
            const toIndex = items.indexOf(toItem)
            if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) {
                return
            }
            const moved = items.splice(fromIndex, 1)[0]
            items.splice(toIndex, 0, moved)
            items.forEach(function (item, index) {
                item.sort_order = index
            })
            this.quote.items = items
            this.$emit('line-items-sync', items)
        }
    },
    mounted: function () {
        this.quote = this.parent_quote;
        this.quoteItems = this.quote.items
        axios.get('/api/setting/display').then(response => {
            this.quoteValidityDays = quoteValidityDaysFromSettings(response.data)
        }).catch(() => {})
        this.$nextTick(() => {
            this.original = clone(this.parent_quote);
        });

        /**
         * Initialise Semantic UI accordion
         */
        $(this.$el).find('.ui.accordion').accordion()

        /**
         * Initialise Semantic UI accordion
         */
        $(this.$el).find('.ui.dropdown').dropdown()

        // TODO - Hack to get quote totals updating
        // setInterval(this.calculateTotals, 1000)
    },
    updated: function () {
      $(this.$el).find('.ui.dropdown').dropdown()
    }
}
</script>

<style>
/* Styles live in app.css (.sidebar-contact-field) so they win over Semantic/grid rules. */
</style>
